<template>
<div>
	<div class="d-flex mt-2 justify-content-between align-items-center">

		<div>
			<button v-if="selectedRecords.length > 0 && !isFinalized" type="button" class="btn btn-light btn-sm" v-on:click="editBulkSelection">
				<i class="fa fa-pencil-alt"></i>
				Bulk Edit
			</button>
		</div>
		<div>
			<button v-if="!isFinalized" class="btn btn-primary" v-on:click="addEquipment">
				<i class="fa fa-plus"></i>
				Add
			</button>
		</div>
	</div>

	<table-list
		record-name="Equipment Item"
		:fields="equipmentFields"
		:hide-record-count="true"
		:records="mutatedEquipmentAdded"
		:simple-delete="true"
		:has-delete="!isFinalized"
		:has-edit="!isFinalized"
		:sortable="true"
		:records-selectable="!isFinalized"
		id-field="equipment_type_id"
		v-on:selectedRecordsChange="setSelectedRecords"
		v-on:edit="editEquipment"
		v-on:delete="removeEquipment">
	</table-list>

	<info-box class="float-right mb-2" 
		label="Total" 
		:value="totalRecordsValue(mutatedEquipmentAdded).toCurrency()">
	</info-box>
	<div style="clear: both;"></div>

	<equipment-type-picker-modal :visible="equipmentTypePickerModal.visible"
		title="Add Equipment"
		:record="equipmentTypePickerModal.selectedType"
		:allow-manual-type="true"
		:confirm-button-text="equipmentTypePickerModal.confirmButtonText"
		v-on:confirmAdd="equipmentAdded"
		v-on:closeModal="equipmentTypePickerModal.visible = false">

		<field label="Price Adjustment"
			col-class="col-md-4"
			:params="{type:'number',step: 0.0001}"
			v-model="equipmentTypePickerModal.externalPayload.price_adjustment">
		</field>

		<field label="Markup"
			col-class="col-md-4"
			:params="{type:'number',step: 0.001}"
			v-model="equipmentTypePickerModal.externalPayload.markup">
		</field>

	</equipment-type-picker-modal>

	<bid-element-bulk-edit-modal :visible="bulkEditModal.visible"
		title="Bulk Edit"
		:records="selectedRecords"
		type="Equipment"
		:bid-id="component ? component.bid_id : false"
		:component="component"
		v-on:saved="$emit('modelChanged')"
		v-on:closeModal="bulkEditModal.visible = false">
	</bid-element-bulk-edit-modal>
</div>
</template>
<script type="text/javascript">

import InfoBox from "@/components/InfoBox"
import TableList from "@/components/TableList"
import Field from "@/components/Field"
import ModalDialog from "@/components/ModalDialog"

import EquipmentTypePickerModal from "@/components/super_components/EquipmentTypePickerModal"
import BidElementBulkEditModal from "@/pages/project/project_tabs/bidding/components/BidElementBulkEditModal"

import ProjectBidMixins from "@/mixins/ProjectBidMixins.js"	

export default {
	name: "EquipmentSection",
	components: {
		TableList,
		InfoBox,
		EquipmentTypePickerModal,
		BidElementBulkEditModal,
		Field,
		ModalDialog
	},
	mixins: [ProjectBidMixins],
	props: ["equipment","component","isFinalized"],
	data() {
		return {
			equipmentLocal: [],
			equipmentTypePickerModal: {
				visible: false,
				type: null,
				selectedType: null,
				confirmButtonText: "Add",
				externalPayload: {
					price_adjustment: 1,
					markup: 1
				}
			},
			bulkEditModal: {
				visible: false
			},
			selectedRecords: [],
			equipmentEditRecordId: null
		}
	},
	watch: {
		equipment() {
			this.equipmentLocal = this.equipment
		}
	},
	computed: {
		mutatedEquipmentAdded() {
			return this.equipmentLocal.map(eq => {

				eq.qtyWithUnit = "0.00 hours"

				if (eq.qty != null) {
					let qty = +eq.qty
					let unit = "hour"
					if ("unit" in eq && eq.unit) {
						if (eq.unit == 'hrs')
							unit = 'hour'
						else
							unit = eq.unit
					}

					eq.qtyWithUnit = qty.toFixed(2) + " " + unit + "s"
				}

				if (!eq.markup)
					eq.markup = 1

				if (!eq.price_adjustment)
					eq.price_adjustment = 1

				eq.markupFormatted = eq.markup
				eq.priceAdjustmentFormatted = eq.price_adjustment

				eq.totalRaw = +eq.qty * +eq.rate * +eq.markup * +eq.price_adjustment

				eq.totalFormatted = eq.totalRaw.toCurrency()

				if (!eq.equipment_type_id) {
					//generate a random manual id
					eq.equipment_type_id = "manual_"+Math.random()
				}

				return eq
			})
		},
	},
	methods: {
		addEquipment() {
			this.equipmentTypePickerModal.visible = true
			this.equipmentTypePickerModal.type = null
			this.equipmentTypePickerModal.confirmButtonText = "Add"

			let defaultPriceAdjustment = this.getDefaultPriceSetting("Equipment","price_adjustment")
			let defaultMarkup = this.getDefaultPriceSetting("Equipment","markup")

			this.equipmentTypePickerModal.externalPayload = {
				markup: defaultMarkup,
				price_adjustment: defaultPriceAdjustment
			}

			this.equipmentTypePickerModal.selectedType = {
				typeName: null,
				rate: null,
				qty: null,
				unit: null,
				equipment_type_id: null
			}

			this.equipmentEditRecordId = false
		},
		editEquipment(record) {

			this.equipmentTypePickerModal.visible = true
			this.equipmentTypePickerModal.selectedType = {
				type_name: record.typeName,
				type_id: record.equipment_type_id,
				rate: record.rate,
				qty: record.qty
			}

			this.equipmentTypePickerModal.confirmButtonText = "Save"

			this.equipmentTypePickerModal.externalPayload = {
				price_adjustment: record.price_adjustment,
				markup: record.markup
			}

			this.equipmentEditRecordId = record.objectRecordId
		},
		setSelectedRecords(records) {
			this.selectedRecords = records
		},
		editBulkSelection() {
			this.bulkEditModal.visible = true
		},
		equipmentAdded(eq) {
			let vm = this

			eq.price_adjustment = this.equipmentTypePickerModal.externalPayload.price_adjustment
			eq.markup = this.equipmentTypePickerModal.externalPayload.markup

			let payload = {
				bid_component_id: this.component.id,
				type: "Equipment",
				qty: eq.qty,
				rate: eq.rate,
				price_adjustment: eq.price_adjustment,
				markup: eq.markup,
				field_values_json: JSON.stringify(eq),
				unit: eq.unit
			}

			if ("equipment_type_id" in eq && !isNaN(parseInt(eq.equipment_type_id))) {
				payload.equipment_type_id = eq.equipment_type_id
				payload.object_id = eq.equipment_type_id
			}
			else {
				payload.equipment_type_id = "manual_"+Math.random()
			}

			if (this.equipmentEditRecordId)
				payload.id = this.equipmentEditRecordId

			this.postData("JobBidComponentObject/save",payload,true).then(response => {
				if (response.success) {
					vm.equipmentTypePickerModal.visible = false
					vm.$emit("modelChanged")
				}
			})
		},
		removeEquipment(eq, index) {
			let vm = this
			this.postData("JobBidComponentObject/delete",{id: eq.objectRecordId},true).then(response => {
				if (response.success) {
					let index = vm.$store.projectBidObjects.findIndex(obj => obj.id == eq.objectRecordId)
					vm.$store.projectBidObjects.splice(index,1)

					vm.$emit("modelChanged")
				}
			})
		},
	},
	created() {
		this.equipmentLocal = this.equipment
	}
}
</script>